import React from 'react'
import Img from 'gatsby-image'

const Image = ({
  src,
  alt,
  fixed,
  fluid,
  objectFit = 'cover',
  objectPosition = '50% 50%',
  ...props
}) => {
  const withSizes = source => ({
    ...source,
    sizes: '(max-width: 2800px) 100vw, 2800px',
  })
  // An array means art direction — each source carries its own media query
  const updatedFluid = Array.isArray(fluid)
    ? fluid.map(withSizes)
    : withSizes(fluid)
  return src ? (
    <img
      width="100%"
      height="100%"
      alt={alt}
      src={src}
      loading="lazy"
      style={{ objectFit, objectPosition }}
      {...props}
    />
  ) : (
    <Img {...props} fluid={updatedFluid} fixed={fixed} />
  )
}

export default Image
